import DetailAnalysisReducer from 'store/detail-analyze/reducers';

export { default as DetailAnalyzeTypes } from 'store/detail-analyze/types';

export default DetailAnalysisReducer;
